import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'textUnit'
})
export class TextUnitPipe implements PipeTransform {
    transform(value: number) {
        if (!value) { return ''; }

        if (value === 1) { return 'characters'; }
        if (value === 2) { return 'words'; }

        return '';
    }
}
